import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = ["src", "onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_viewer = _resolveComponent("viewer");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.css.wrap)
  }, [_createElementVNode("div", {
    class: _normalizeClass([_ctx.css.smallbox, _ctx.css.common]),
    ref: "smallbox"
  }, [_createVNode(_component_viewer, {
    trigger: $data.curImage
  }, {
    default: _withCtx(() => [$data.curImage ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      src: $data.curImage,
      style: {
        "width": "100%",
        "height": "100%",
        "z-index": "1",
        "position": "absolute",
        "top": "0",
        "left": "0px"
      }
    }, null, 8, _hoisted_1)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["trigger"])], 2), $data.arr.length ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass([_ctx.css.goodsimgs, "row row-between"])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr, (item, index) => {
    return _openBlock(), _createElementBlock("img", {
      src: item,
      class: _normalizeClass(["pointer", [_ctx.css.img, _ctx.css.common, {
        [_ctx.css.active]: $data.curImage == item
      }]]),
      onClick: $event => $options.onImageClick(item),
      style: {
        "margin-right": "10px"
      }
    }, null, 10, _hoisted_2);
  }), 256))], 2)) : _createCommentVNode("", true)], 2);
}